import { KpiSection } from '../../../../data-models/company-financials.data-model';
import { RendererType } from '../../../../data-models/field-definition';
import {
  BasicFormConfig,
  createFieldFormConfigDataModel,
  IFieldFormConfig,
} from '../../../../data-models/field2.data-model';
import { IFormatterDataModel } from '../../../../data-models/formatter.data-model';
import {
  CustomTemplateSectionType,
  IMenuSectionOption,
  MenuSectionOptions,
  TemplateSectionFormValues,
} from '../../../../schemas/kpi-template.schema';
import { NumericFormattersConfig } from '../../../../util/formatters/NumericFormatters';

type SectionSlice = Pick<TemplateSectionFormValues, 'type' | 'sectionType'>;

export function getDefaultSectionType(type: CustomTemplateSectionType, sections: SectionSlice[]): KpiSection {
  if (type !== CustomTemplateSectionType.quantitative) {
    return KpiSection.actual;
  }
  const existing = sections.find((s) => s.type === CustomTemplateSectionType.quantitative);
  if (!existing) {
    return KpiSection.actual;
  }
  return existing.sectionType === KpiSection.actual ? KpiSection.budget : KpiSection.actual;
}

export function isSectionToggleDisabled(type: CustomTemplateSectionType, quantitativeCount: number): boolean {
  return type === CustomTemplateSectionType.quantitative && quantitativeCount >= 2;
}

export function getDefaultFormMetaForSection(
  type: CustomTemplateSectionType
): IFieldFormConfig<unknown, BasicFormConfig> {
  switch (type) {
    case CustomTemplateSectionType.quantitative:
      return createFieldFormConfigDataModel({
        renderer: { type: RendererType.numeric, config: {} },
        formatter: NumericFormattersConfig.numeric as IFormatterDataModel<BasicFormConfig>,
      });
    case CustomTemplateSectionType.textual:
      return createFieldFormConfigDataModel({
        renderer: { type: RendererType.text, config: {} },
      });
    case CustomTemplateSectionType.file:
      return createFieldFormConfigDataModel({
        renderer: { type: RendererType.fileUpload, config: {} },
      });
    case CustomTemplateSectionType.date:
      return createFieldFormConfigDataModel({
        renderer: { type: RendererType.date, config: {} },
      });
  }
}

export interface MenuOptionsConfig {
  showFileOption?: boolean;
}

export function getAvailableMenuOptions(
  sections: SectionSlice[],
  config: MenuOptionsConfig = {}
): readonly IMenuSectionOption[] {
  const { showFileOption = true } = config;

  const quantitativeTypes = new Set(
    sections.filter((s) => s.type === CustomTemplateSectionType.quantitative).map((s) => s.sectionType)
  );
  const quantitativeExhausted =
    quantitativeTypes.has(KpiSection.actual) && quantitativeTypes.has(KpiSection.budget);

  return MenuSectionOptions.filter((opt) => {
    if (opt.type === CustomTemplateSectionType.quantitative && quantitativeExhausted) {
      return false;
    }
    if (opt.type === CustomTemplateSectionType.file && !showFileOption) {
      return false;
    }
    return true;
  });
}
